import React, { useState, useEffect } from 'react';
import {
    Box, Tabs, TabList, TabPanels, Tab, TabPanel,
    Text, VStack, HStack, Spinner, Center, Badge, Flex
} from '@chakra-ui/react';
import DashboardLeavesWidget from './DashboardLeavesWidget';
import { authAPI } from '../services/api';

const DashboardLogisticsWidget = () => {
    return (
        <Box h="100%" bg="white" p={2} display="flex" flexDirection="column">
            <Tabs variant="soft-rounded" size="sm" h="100%" display="flex" flexDirection="column">
                <TabList mb={2} px={1}>
                    <Tab fontWeight="bold" color="gray.500" _selected={{ color: 'blue.600', bg: 'blue.50' }}>今日請假</Tab>
                    <Tab fontWeight="bold" color="gray.500" _selected={{ color: 'orange.600', bg: 'orange.50' }}>今日訂餐</Tab>
                </TabList>
                <TabPanels flex="1" overflow="hidden">
                    <TabPanel p={0} h="100%">
                        <Box h="100%" borderRadius="md" border="1px solid" borderColor="gray.200" overflow="hidden">
                            <DashboardLeavesWidget />
                        </Box>
                    </TabPanel>
                    <TabPanel p={0} h="100%">
                        <Box h="100%" borderRadius="md" border="1px solid" borderColor="gray.200" overflow="hidden">
                            <DashboardLunchWidget />
                        </Box>
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};

// Internal Component for Lunch Stats
const DashboardLunchWidget = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                // Get today's date
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const today = `${year}-${month}-${day}`;

                const res = await authAPI.getMe(); // Need institution ID
                if (res.data.institution_id) {
                    const statsRes = await authAPI.lunch.getStats(today, res.data.institution_id);
                    setStats(statsRes.data);
                }
            } catch (error) {
                console.error("Failed to fetch lunch stats", error);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    if (loading) return <Center h="100%"><Spinner size="sm" /></Center>;

    if (!stats || stats.total_count === 0) {
        return (
            <Center h="100%" flexDirection="column">
                <Text fontSize="sm" color="gray.500">今日無訂餐</Text>
            </Center>
        );
    }

    return (
        <Box
            h="100%"
            overflowY="auto"
            pr={2}
            sx={{
                '&::-webkit-scrollbar': { width: '8px' },
                '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                '&::-webkit-scrollbar-thumb': { background: '#A0AEC0', borderRadius: '4px' },
            }}
        >
            <VStack spacing={3} align="stretch">
                {/* Total Summary */}
                <Box bg="orange.50" p={2} borderRadius="md" textAlign="center">
                    <Text fontSize="xs" color="orange.600" fontWeight="bold">今日總數</Text>
                    <Text fontSize="2xl" fontWeight="bold" color="orange.600">{stats.total_count}</Text>
                </Box>

                {/* List by Class */}
                {stats.breakdown.map((item) => (
                    <Box key={item.class_id} p={2} borderBottom="1px solid" borderColor="gray.100">
                        <Flex justify="space-between" align="center" mb={1}>
                            <Text fontSize="sm" fontWeight="bold">{item.class_name}</Text>
                            <Badge colorScheme="orange">{item.count} 份</Badge>
                        </Flex>
                        <Text fontSize="xs" color="gray.500" noOfLines={2}>
                            {item.student_names.join(', ')}
                        </Text>
                    </Box>
                ))}
            </VStack>
        </Box>
    );
};

export default DashboardLogisticsWidget;
